<template>
    <div>
        <v-card-subtitle class="font-italic" v-if="conclusion.updated_at">Zuletzt bearbeitet am {{conclusion.updated_at}}</v-card-subtitle>
        <v-card-title>
            Stärken & Entwicklungspotenziale
        </v-card-title>
        <v-card-text>
            <v-textarea outlined label="Fachkompetenz" :readonly="readonly" v-model="conclusion.professional_skills"/>
            <v-textarea outlined label="Methodenkompetenz" :readonly="readonly" v-model="conclusion.method_skills"/>
            <v-textarea outlined label="Sozial-/Persönlichkeitskompetenz" :readonly="readonly" v-model="conclusion.social_skills"/>
        </v-card-text>

        <v-card-title id="advancements">
            Weiterentwicklung
        </v-card-title>

        <v-card-text v-if="conclusion.advancements && conclusion.advancements.length > 0">
            <v-card  outlined v-for="(item, index) in conclusion.advancements" :key="index" class="mt-2">
                <v-card-title class="py-2">
                    <div style="position: absolute; margin-top: -80px; height: 1px; width: 1px; z-index: -1;" :id="item.id"></div>
                    <v-spacer/>
                    <v-btn :disabled="readonly" x-small depressed fab color="secondary" @click="deleteAdvancement(index)"><v-icon>mdi-close</v-icon></v-btn>
                    <v-dialog v-model="conclusion.advancements[index].dialog" style="max-width: 1200px;" width="800">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="readonly" x-small depressed fab color="secondary" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                Weiterentwicklung bearbeiten
                            </v-card-title>
                            <v-card-text>
                                <v-textarea outlined label="Konkrete Planungen" v-model="item.plans"/>
                                Konkrete Maßnahmen
                                <v-select outlined label="Typ" v-model="item.actions_type" :items="itemsType"/>
                                <v-select outlined label="Verantwortlicher" v-model="item.actions_responsible" :items="itemsResponsible"/>
                                <v-textarea outlined label="Anmerkungen" v-model="item.note"/>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        color="error"
                                        outlined
                                        @click="conclusion.advancements[index].dialog = false">Abbrechen</v-btn>
                                <v-btn
                                        color="success"
                                        depressed
                                        @click.stop="updateAdvancement(index)">Speichern</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-title>
                <v-card-text>
                    <div v-if="item.plans">
                        <div class="subtitle-1 black--text">Konkrete Planung</div>
                        {{item.plans}}
                    </div>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" v-if="item.actions_type">
                            <div class="subtitle-1 black--text">Typ</div>
                            <span v-if="item.actions_type === 'seminar'">Seminar</span>
                            <span v-if="item.actions_type === 'coaching'">Coaching</span>
                            <span v-if="item.actions_type === 'literature'">Literatur</span>
                            <span v-if="item.actions_type === 'other'">Sonstiges</span>
                        </v-col>
                        <v-col cols="12" md="6" v-if="item.actions_responsible">
                            <div class="subtitle-1 black--text">Verantwortlicher</div>
                            <span v-if="item.actions_responsible === 'employee'">Mitarbeiter</span>
                            <span v-if="item.actions_responsible === 'executive'">Führungskraft</span>
                            <span v-if="item.actions_responsible === 'hr'">Personalabteilung</span>
                        </v-col>
                    </v-row>
                    <div v-if="item.note">
                        <div class="subtitle-1 black--text">Notiz</div>
                        {{item.note}}
                    </div>
                </v-card-text>
            </v-card>
        </v-card-text>
        <v-card-subtitle>
            Hinweis: Bitte jede Planung einzeln hinzufügen.
        </v-card-subtitle>
        <v-card-text>
            <v-form ref="advancements">
                <v-textarea :readonly="readonly" outlined label="Konkrete Planungen" v-model="advancement.plans"/>
                Konkrete Maßnahmen
                <v-select :readonly="readonly" outlined label="Typ" v-model="advancement.actions_type" :items="itemsType"/>
                <v-select :readonly="readonly" outlined label="Verantwortlicher" v-model="advancement.actions_responsible" :items="itemsResponsible"/>
                <v-textarea :readonly="readonly" outlined label="Anmerkungen" v-model="advancement.note"/>
                <v-btn :disabled="readonly" outlined color="primary" @click="storeAdvancement">
                    <v-icon>mdi-plus</v-icon>Hinzufügen
                </v-btn>
            </v-form>
        </v-card-text>

        <v-card-title>
            Sonstige Planungen des Mitarbeiters
        </v-card-title>
        <v-card-text>
            <v-textarea :readonly="readonly" outlined label="Konkrete Planungen" placeholder="z.B. Elternzeit, Altersteilzeit etc." v-model="conclusion.other_plans"/>
            <v-textarea :readonly="readonly" outlined label="Anmerkungen & Zeitraum" v-model="conclusion.other_notes"/>
        </v-card-text>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        props: ['readonly', 'payload', 'payloadAdvancement'],
        name: "",
        data: () => ({
            advancement: {
                plans: '',
                actions_type: '',
                actions_responsible: '',
                note: '',
            },
            conclusion: {
                id: '',
                is_released: false,
                updated_at: '',
                professional_skills: '',
                method_skills: '',
                social_skills: '',
                advancements: [],
                other_plans: '',
                other_notes: '',
            },
            itemsResponsible: [
                { text: 'Mitarbeiter', value: 'employee'},
                { text: 'Führungskraft', value: 'executive'},
                { text: 'Personalabteilung', value: 'hr'},
            ],
            itemsType: [
                { text: 'Seminar', value: 'seminar'},
                { text: 'Coaching', value: 'coaching'},
                { text: 'Literatur', value: 'literature'},
                { text: 'Sonstiges', value: 'other'},
            ],
        }),
        methods: {
            ...mapActions({}),
            storeAdvancement(){
                this.axios.post('/conclusion-advancements', {
                    'advancement' : this.advancement,
                    'conclusion' : this.conclusion.id ? this.conclusion.id : false,
                }).then( (response) =>{
                    this.$toast.success('Die Weiterentwicklung wurde erfolgreich hinzugefügt.');
                    let advancement = response.data;
                    advancement.dialog = false;
                    this.conclusion.advancements.push({...advancement});
                    this.$refs.advancements.reset();
                }).catch( () => {
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.')
                });
            },
            updateAdvancement(index){

                this.axios.patch('/conclusion-advancements/' + this.conclusion.advancements[index].id, {
                    'advancement' : this.conclusion.advancements[index],
                }).then( () =>{
                    this.$toast.success('Die Weiterentwicklung wurde erfolgreich aktualisiert.');
                    this.reloadData();
                    /*this.conclusion.advancements[index] = {...response.data.data};*/
                    /*this.$set(this.conclusion.advancements[index], 'dialog', false);*/
                }).catch( () => {
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.')
                });
            },
            deleteAdvancement(index){
                this.axios.delete('/conclusion-advancements/' + this.conclusion.advancements[index].id, {
                    'advancement' : this.conclusion.advancements[index],
                }).then( () =>{
                    this.$toast.success('Die Weiterentwicklung wurde erfolgreich gelöscht.');
                    /*this.conclusion.advancements[index] = {...response.data.data};*/
                    /*this.$set(this.conclusion.advancements[index], 'dialog', false);*/
                }).catch( () => {
                    this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.')
                });
                this.conclusion.advancements.splice(index, 1);
            },

            closeDialog(index){
                this.conclusion.advancements[index].dialog = false;
            },

            reloadData(){
                this.$emit('reload')
            }

        },
        mounted() {
            if (this.payload.id){
                this.conclusion = this.payload;
            }
            else {
                this.$emit('pass', this.conclusion);
            }
            if (this.payloadAdvancement){
                this.advancement = this.payloadAdvancement;
            }
            else{
                this.$emit('toAdvancement', this.advancement);
            }


        },
        watch: {
            payload: function(val){
                if (val.id){
                    this.conclusion = val;
                }
            },
            conclusion: function (val) {
                if (val.id){
                    this.$emit('pass', val);
                }
            },
            advancement: function (val) {
                this.$emit('toAdvancement', val);
            }
        },
    }
</script>

<style scoped>

</style>